import { StatusOption } from '@/models/file-app.model';
import { NavLink } from '@/models/types';
import moment from 'moment';

export const optionsItemsPerPage: number[] = [10, 15, 20, 50];

export const optionsStatusList: StatusOption[] = [
  { name: 'status_list.active', value: true },
  { name: 'status_list.inactive', value: false },
];

export const firstView = '/operaciones/presentes_futuras';

export const AppNavLinks: NavLink[] = [
  // { name: "Padre1", icon: "", path: "", children: [
  //   {name: "Example1", icon: "", path: "/Padre/Example", children: [
  //     // {name: "Edit1", icon: "", path: "/Padre/Example/Edit"},
  //   ] },

  // ] },
  {
    name: 'nav_bar.operaciones',
    icon: '',
    path: '',
    children: [
      {
        moduleAccess: 'Operaciones',
        name: 'nav_bar.presentes_futuras',
        icon: '',
        path:
          '/operaciones/presentes_futuras?q-fechaDesde=' +
          moment(new Date()).format('YYYY-MM-DD'),
      },
      {
        moduleAccess: 'Estrategias',
        name: 'nav_bar.estrategias',
        icon: '',
        path: '/operaciones/estrategias',
      },
      {
        moduleAccess: 'Operaciones',
        name: 'nav_bar.historico',
        icon: '',
        path:
          '/operaciones/Historico?q-fechaHasta=' +
          moment(new Date()).format('YYYY-MM-DD') +
          '&q-fechaDesde=' +
          moment(new Date()).add(-1, 'days').format('YYYY-MM-DD'),
      },
    ],
  },
  {
    name: 'nav_bar.cierres',
    icon: '',
    path: '',
    children: [
      {
        moduleAccess: 'Calendario',
        name: 'nav_bar.calendario',
        icon: '',
        path: '/Cierres/Calendarios',
      },
      {
        moduleAccess: 'Cierres',
        name: 'nav_bar.ejecucion',
        icon: '',
        path: '/Cierres/Ejecuciones',
      },
      {
        moduleAccess: 'Cierres',
        name: 'nav_bar.historico',
        icon: '',
        path: '/Cierres/Historicos',
        //path: '/Cierres/Historicos?q-hasta='+ moment(new Date()).add(-1, 'days').format("YYYY-MM-DD")+'&q-desde='+ moment(new Date()).add(-8, 'days').format("YYYY-MM-DD"),
      },
    ],
  },
  {
    name: 'nav_bar.alertas',
    icon: '',
    path: '',
    children: [
      {
        moduleAccess: 'Alertas',
        name: 'nav_bar.notificaciones',
        icon: '',
        path: '/Alertas/Notificaciones',
      },
      {
        moduleAccess: 'Alertas',
        name: 'nav_bar.suscripciones',
        icon: '',
        path: '/Alertas/Suscripciones',
      },
    ],
  },
  {
    name: 'nav_bar.administracion',
    icon: '',
    path: '',
    children: [
      {
        moduleAccess: 'Administracion',
        name: 'nav_bar.productos',
        icon: '',
        path: '/Administracion/Productos',
      },
      {
        moduleAccess: 'Administracion',
        name: 'nav_bar.usuarios',
        icon: '',
        path: '/Administracion/Usuarios',
      },
      {
        moduleAccess: 'Administracion',
        name: 'nav_bar.reportes',
        icon: '',
        path: '/Administracion/Reportes',
      },
      {
        moduleAccess: 'Administracion',
        name: 'nav_bar.mercados',
        icon: '',
        path: '/Administracion/Mercados',
      },
      {
        moduleAccess: 'Administracion',
        name: 'nav_bar.mesas',
        icon: '',
        path: '/Administracion/Mesas',
      },
    ],
  },
];
export const AppNavLinksBottom: NavLink[] = [
  {
    name: 'nav_bar.ayuda',
    icon: 'info',
    path: '/help',
    isExternal: false,
  },
];
